<template>
    <g>
        <rect 
            v-bind="{ 
                class : 'tool_svgElem',
                id     : tool.id + '-body',
                x      : Math.min(tool.coords.pts[0].x, tool.coords.pts[1].x), 
                y      : Math.min(tool.coords.pts[0].y, tool.coords.pts[1].y),
                width  : Math.abs(tool.coords.pts[1].x - tool.coords.pts[0].x),
                height : Math.abs(tool.coords.pts[1].y - tool.coords.pts[0].y),
                fill   : fill,
                fillOpacity : 0.2,          
            }"
        />
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { tools } from '../../mixins/tools';

// =========================================================================================

export default {
    name : 'retangCMP',

    props: {
        fill  : { type: String  }
    }, 

    // -----------------------------------------------------------------

    mixins: [tools],

    // -----------------------------------------------------------------

    data () {
        return {
        }
    },

    // -----------------------------------------------------------------

    computed: {
    },

    // -----------------------------------------------------------------

    methods: {
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>